// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"417b48da","787":"e0eb040d"}[chunkId] + ".chunk.js";
};